<template>
  <div>
    <v-row v-if="showItem" no-gutters><v-col>{{item.label}}</v-col></v-row>
    <v-row v-if="showItem" no-gutters justify="space-between">
      <v-col>
        <v-text-field
          :class="classItem(1)"
          class="text-caption"
          :label="item.label1"
          v-model="item.value1"
          :rules="rulesValidation"
          :disabled="!updateTrigger || disabled || item.readonly"
          @change="onChange1">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          :class="classItem(2)"
          :label="item.label2"
          v-model="item.value2"
          :rules="rulesValidation"
          :disabled="!updateTrigger || disabled || item.readonly"
          @change="onChange2">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          :class="classItem(3)"
          :label="item.label3"
          v-model="item.value3"
          :rules="rulesValidation"
          :disabled="!updateTrigger || disabled || item.readonly"
          @change="onChange3">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          :class="classItem(4)"
          :label="item.label4"
          v-model="item.value4"
          :rules="rulesValidation"
          :disabled="!updateTrigger || disabled || item.readonly"
          @change="onChange4">
          <template v-slot:append>
            <v-icon small class="mr-2" title="Blocca modifica su ricalcolo" @click="toggleLock">{{iconaBlocco}}</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { validazioni } from '@/mixins/validazioni.js'
  
  export default {
    name: 'quattroTesti',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: { type: Number, default: 1 },
      index: Number,
      lockValori: { type: Number, default: 0 }
    },
    data: (vm) => ({
    }),
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return  _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      iconaBlocco() {
        if (this.lockValori === 0) return ''
        return this.lockValori === 2 ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
      }
    },
    methods: {
      classItem(i) {
        if (this.item && _.get(this.item, `classTestCondition${i}`)) {
          const vc = _.get(this, _.get(this.item, `classTestCondition${i}`), false)
          return vc ? _.get(this.item, `classIfCondition${i}`) : ''
        } else {
          return ''
        }
      },      
      onChange1(value) {
        this.$emit('change', { model: this.item.model1, subModel: this.item.subModel1, value, index: this.index })
      },
      onChange2(value) {
        this.$emit('change', { model: this.item.model2, subModel: this.item.subModel2, value, index: this.index })
      },
      onChange3(value) {
        this.$emit('change', { model: this.item.model3, subModel: this.item.subModel3, value, index: this.index })
      },
      onChange4(value) {
        this.$emit('change', { model: this.item.model4, subModel: this.item.subModel4, value, index: this.index })
      },
      toggleLock() {
        this.$emit('toggleLock')
      }          
    }
  }
</script>